module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-footer.f4d9baa9.png";